import { IPublicClientApplication } from "@azure/msal-browser";
import { getSignedInAccount } from "auth/utils/getSignedInAccount";
import { scopes } from "auth/utils/scopes";

export const getAccessRequest = (pca?: IPublicClientApplication) => {
  if (!pca) throw new Error("PCA is not initialized");
  const account = getSignedInAccount(pca);
  if (!account) return null;

  const request = {
    scopes,
    account: account,
  };

  return request;
};
